<template>
  <div class="search" :class="{ 'search_size-small': size === 'small' }">
    <el-select
      v-model="value"
      multiple
      filterable
      :filter-method="saveEnteredValue"
      allow-create
      default-first-option
      popper-class="hide-dropdown"
      :popper-append-to-body="false"
      :placeholder="placeholder"
      @change="searchHandle"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <button type="button" @click.prevent="searchByClickButton">
      <img src="../../assets/icons/i_search.svg" alt="search" />
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SearchMultiple",
  props: {
    placeholder: {
      type: String,
      default: "Search the site",
    },
    size: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      value: [],
      enteredValue: null,
      fullscreenLoading: false,
    };
  },
  computed: {
    ...mapState("Search", [
      "searchText",
      "searchSidebarText",
      "searchMultiple",
    ]),
  },
  watch: {
    searchText: {
      deep: true,
      handler(val) {
        if (val && val.length) {
          this.value = this.searchMultiple;
        }
      },
    },
    searchSidebarText: {
      deep: true,
      handler(val) {
        if (val && val.length) {
          this.value = this.searchMultiple;
        }
      },
    },
    $route() {
      const query = this.$route.query.query;
      if (query && query.length) {
        // eslint-disable-next-line quotes
        const arr = query.slice(1, -1).split('" "');
        this.value = arr;
        this.$store.commit("Search/setData", {
          label: "searchMultiple",
          data: arr,
        });
      } else {
        this.value = [];
        this.$store.commit("Search/setData", {
          label: "searchMultiple",
          data: [],
        });
        this.$store.commit("Search/setData", {
          label: "searchText",
          data: null,
        });
        this.$store.commit("Search/setData", {
          label: "searchSidebarText",
          data: null,
        });
      }
    },
  },
  mounted() {
    const query = this.$route.query.query;

    if (query && query.length) {
      // eslint-disable-next-line quotes
      const arr = query.slice(1, -1).split('" "');
      this.value = arr;
      this.$store.commit("Search/setData", {
        label: "searchMultiple",
        data: arr,
      });
    }
  },
  destroyed() {
    // Clear store
    this.$store.commit("Search/setData", {
      label: "searchMultiple",
      data: null,
    });
  },
  methods: {
    saveEnteredValue(query) {
      this.enteredValue = query;
    },
    searchByClickButton() {
      if (this.enteredValue && this.enteredValue.length) {
        const newValue = this.value.slice();
        newValue.push(this.enteredValue);

        this.value = newValue;

        this.searchHandle();
        this.enteredValue = null;
      }
    },
    searchHandle() {
      this.$emit("handleGetValue", this.value);
      const param = this.value
        .filter((i) => i.trim().length > 0)
        .map((i) => `"${i}"`)
        .join(" ");
      if (this.$matomo) {
        console.log("Search", "Multiple search text", this.value);
        this.$matomo.trackEvent("Search", "Multiple search text", this.value);
      }
      if (this.$churnZero) {
        this.$churnZero.trackEvent("Search", "Multiple search text");
      }
      const query = {};
      query.query = this.value.length ? param : [];
      if (this.value.length) {
        query.query = param;
      } else {
        query.query = [];
        this.$store.commit("Search/setData", {
          label: "searchText",
          data: null,
        });
        this.$store.commit("Search/setData", {
          label: "searchSidebarText",
          data: null,
        });
      }
      if (this.value !== this.$store.state.Search.searchMultiple) {
        this.$store.commit("Search/setData", {
          label: "searchMultiple",
          data: this.value,
        });
        this.$store.commit("Search/setSearchQuery", {
          label: "searchQuery",
          query,
          relevance: true,
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.search {
  position: relative;

  @include below($md) {
    width: 100%;
  }

  .el-select {
    width: 100%;

    &__tags {
      padding: 0 3rem 0 1rem;

      &-text {
        max-width: 32rem;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        vertical-align: top;

        @include below($sm) {
          max-width: 15rem;
        }
      }
    }

    .el-input {
      input {
        width: 100%;
        height: 5rem;
        border: 1px solid $light_blue;
        font-size: 1.8rem;
        padding: 0 5.5rem 0 2.5rem;
        border-radius: 0;
      }

      &__suffix {
        display: none;
      }
    }

    &-dropdown {
      &.hide-dropdown {
        display: none;
      }
    }
  }

  button {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    height: 100%;
    width: 5rem;
    background: $red;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.85;
    }
  }

  &_size-small {
    .el-select {
      width: 100%;

      &__tags {
        padding: 0 3rem 0 0;
      }

      .el-input {
        input {
          height: 4rem;
          font-size: 1.4rem;
          padding: 0 4.5rem 0 1.5rem;
          border-radius: 0;
        }

        &__suffix {
          display: none;
        }
      }
    }

    button {
      $size: 4rem;

      height: $size;
      width: $size;

      img {
        $size: 1.6rem;

        height: $size;
        width: $size;
      }
    }
  }
}
</style>
